// extracted by mini-css-extract-plugin
export default {"container":"ProductsGraph_container__jSEot"};